import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-496732c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-bar-divider" }, null, -1))
const _hoisted_3 = { class: "person" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "person-name pl-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

import { getUserPhotoUrl } from "@/common/urls";
import TopBarButton from "@/components/topbar/TopBarButton.vue";
import { computed, ref, reactive, watch } from "vue";
import Description from "@/components/util/Description.vue";
import { Authorization } from "@/services/authenticate";
import { useAzureStore } from "@/stores/azure";
import { isDevelopment } from "@/common/env";

const homePageLink =
  "https://abb.sharepoint.com/sites/NO-CompetenceLibrary/SitePages/TeamView.aspx";
const requestHelpLink =
  "https://abb.sharepoint.com/sites/NO-CompetenceLibrary/Lists/BUOGCSupport/AllItems.aspx?Application=U3t";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const state = reactive({ 
  userImageBackground: `url(${useAzureStore().loadPhoto}), white`
});
const azureStore = useAzureStore();

const createBlobUrl = (photo: any) => {
  if (photo) {
    const blob = new Blob([photo], { type: "image/jpeg" });
    return URL.createObjectURL(blob);
  }
  return undefined;
};

const description = ref(false);

const open = () => {
  description.value = true;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TopBarButton, {
        icon: "fa-solid fa-house",
        title: "Home",
        href: homePageLink,
        class: "btn-toolbox--home"
      }),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (!_unref(azureStore).getPhotoLoader)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: createBlobUrl(_unref(azureStore).getPhoto),
              alt: "User Photo",
              class: "person-photo person-photo--rounded"
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(Authorization).accountName), 1)
      ]),
      _hoisted_6,
      _createVNode(TopBarButton, {
        icon: "fa-solid fa-info",
        title: "Description",
        onClick: open
      }),
      _createVNode(TopBarButton, {
        icon: "fa-solid fa-question-circle",
        title: "Request help",
        href: requestHelpLink,
        target: "_blank"
      })
    ]),
    (description.value)
      ? (_openBlock(), _createBlock(Description, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (description.value = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})